module.exports = __webpack_public_path__ + "static/media/manLookingUp.a0eaa4b4.png";